import dayjs from 'dayjs';
import { useMemo } from 'react';
import { HasuraApiClient } from '@fourthwall/services/dist/HasuraApiClient';
import { createQueryHook } from '@fourthwall/utils/dist/queries';
import * as Sentry from '@sentry/react';
import { useCurrentShopQuery } from '../../../hooks/useCurrentShopQuery';
export const useUserLifecycleQuery = createQueryHook(HasuraApiClient.getUserLifecycleIntent, {
    queryKey: ['userLifecycleIntent'],
});
const DAYS_FOR_RECENT_LOGIN = 14;
const DAYS_FOR_RECENT_ACTIVITY = 30;
const MIN_PRODUCTS_FOR_EARN_MORE = 2;
const MIN_ORDERS_FOR_EARN_MORE = 1;
export const useUserLifecycleQueryWithShop = () => {
    const { currentShopQuery } = useCurrentShopQuery();
    const shopId = currentShopQuery.data?.id;
    const params = useMemo(() => {
        if (!shopId)
            return {
                shopId: '',
                offersCreatedAfter: '',
                sampleOrdersCreatedAfter: '',
            };
        const dateString = dayjs().subtract(DAYS_FOR_RECENT_ACTIVITY, 'day').toISOString();
        return {
            shopId,
            offersCreatedAfter: dateString,
            sampleOrdersCreatedAfter: dateString,
        };
    }, [shopId]);
    const { userLifecycleIntentQuery } = useUserLifecycleQuery([params], {
        enabled: Boolean(shopId),
        onError: (error) => {
            Sentry.captureException(error);
        },
    });
    const lifecycle = useMemo(() => {
        if (!userLifecycleIntentQuery.data)
            return undefined;
        // eslint-disable-next-line camelcase
        const { hubspot_shop, offers_aggregate, orders_aggregate } = userLifecycleIntentQuery.data;
        // eslint-disable-next-line camelcase
        const lastLoginAt = hubspot_shop?.[0]?.last_login_at;
        const loggedInWithinRecentPeriod = lastLoginAt
            ? dayjs().diff(dayjs(lastLoginAt), 'day') < DAYS_FOR_RECENT_LOGIN
            : false;
        // eslint-disable-next-line camelcase
        const productCount = offers_aggregate?.aggregate?.count ?? 0;
        // eslint-disable-next-line camelcase
        const ordersCount = orders_aggregate?.aggregate?.count ?? 0;
        if (loggedInWithinRecentPeriod &&
            (productCount >= MIN_PRODUCTS_FOR_EARN_MORE || ordersCount >= MIN_ORDERS_FOR_EARN_MORE)) {
            return 'EARN_MORE';
        }
        return 'LAUNCH_MORE_PRODUCTS';
    }, [userLifecycleIntentQuery.data]);
    return {
        lifecycle,
        isLoading: userLifecycleIntentQuery.isLoading || currentShopQuery.isLoading,
    };
};
